import { Box, BoxProps } from '@mui/material';
import { getConfig } from '../../../utils/config';

const { drawerWidth } = getConfig();

export const Content = ({ sx, children, ...rest }: BoxProps) => (
  <Box
    sx={{
      height: '100vh',
      width: '100%',
      maxWidth: {
        xs: '100%',
        sm: `calc(100% - ${drawerWidth}px)`, // this must always be the same breakpoint as the drawer toggle breakpoint
      },
      padding: {
        xs: 2,
        md: 4,
      },
      ...sx,
    }}
    position={'relative'}
    {...rest}
  >
    {children}
  </Box>
);
